import {reverse} from '@utils/helper';

const IS_FEED_STATUS = {
  IS_NOT_SEND: {
    id: 0,
    text: '不发博'
  },
  IS_SEND: {
    id: 1,
    text: '发博',
  }
};
const REVERSE_IS_FEED_STATUS = reverse(IS_FEED_STATUS);

export { IS_FEED_STATUS, REVERSE_IS_FEED_STATUS };
